import React from 'react';
import { TableColumn } from "tea-component";
import EllipsisTextBubble from "@gp/components/EllipsisTextBubble";
import { getFormatNumPlus, getValidDate, toFirstUpperCase } from '@gp/utils/common';

const getColumns = (
  colList: string[],
  isFixedFirstColumn = true,
  data: orgHeadcountsDataTypes,
) => {
  const opt: 	TableColumn<any>[] = [
    {
      key: "metric",
      header: 'Category',
      width: 200,
      align: 'left',
      fixed: isFixedFirstColumn ? 'left' : undefined,
      render: (cvm: any) => {
        return (
          <EllipsisTextBubble
            text={cvm?.metric || '-'}
          />
        );
      },
    },
  ];
  if (Array.isArray(colList) && colList?.length) {
    for (let i = 0; i < colList?.length; i ++) {
      const t: string = colList?.[i], dataList = data?.dataList;
      let label = '';
      if (Array.isArray(dataList)) {
        for (let j = 0, l = dataList?.length; j < l; j ++) {
          const k = dataList?.[j];
          if (getValidDate(k?.date, 'YYYY-MM') === t) {
            label = toFirstUpperCase(k?.valueType);
          }
        }
      }
      opt.push({
        key: t,
        header: ( <div>{t} <br /> ({label || '-'})</div> ),
        width: 130,
        align: 'right',
        render: (cvm: any) => {
          return getFormatNumPlus(cvm?.[t]);
        },
      });
      // 如果只有一列时间，加一列空的占位，使得数据居中一些
      if (colList?.length === 1) {
        opt.push({
          key: 'empty_col',
          header: null,
          width: 200,
          align: 'right',
          render: (cvm: any) => {
            return null;
          },
        });
      }
    }
  }

  return opt;
}

export {
  getColumns,
}
